export default function cartRecommendations() {
  return {
    products: [],
    loading: false,
    error: false,
    productId: null,
    showSwiper: false,
    abortController: null,

    fetchIfChanged(productId) {
      if (productId === this.productId) return;
      this.productId = productId;

      if (!productId) {
        this.products = [];
        this.showSwiper = false;
        this.error = false;
        return;
      }

      this.fetchRecommendations(productId);
    },

    async fetchRecommendations(productId) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      this.loading = true;
      this.showSwiper = false;
      this.error = false;

      try {
        const res = await fetch(
          `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=6`,
          { signal: this.abortController.signal }
        );
        if (!res.ok) throw new Error(`${res.status}`);
        const { products } = await res.json();
        this.products = products.filter(p => p.id !== productId);
      } catch (e) {
        if (e.name === 'AbortError') return;
        this.products = [];
        this.error = true;
      } finally {
        this.loading = false;
        if (this.products.length > 0) {
          await this.$nextTick();
          this.showSwiper = true;
        }
      }
    },
  };
}
